export const AssetsPie = {
  name: 'Asset Composition Portfolio (Gross %) For Iam Defined Benefit - Dec 2007',
  type: 'pie',
  data: [
    { name: 'Absolute Return', y: 10.7330426573753 },
    { name: 'Cash', y: -4.76051047444344 },
    { name: 'Fixed Income Long Only', y: 24.6169820427895 },
    { name: 'Private Equity', y: 5.50400204956532 },
    { name: 'Public Equity', y: 52.9121935367584 },
    { name: 'Real Estate', y: 10.9942905604839 },
  ],
};
